import * as React from "react"
import { Checklist, ChecklistItem } from "@/components/Checklist"

const FeatureChecklist = ({
  title,
  items,
  dark = true,
  className = "checklist__border p-8",
  itemClassName = "",
}) => {
  return (
    <div className={className}>
      <h4>
        <strong>{title}</strong>
      </h4>
      <Checklist
        className={` ${dark ? "checklist--dark" : "checklist--light"}`}
      >
        {items.map(item => (
          <ChecklistItem className={itemClassName} key={item}>
            {item}
          </ChecklistItem>
        ))}
      </Checklist>
    </div>
  )
}

export default FeatureChecklist
